import Swal from 'sweetalert2';

// --- SweetAlert2 Theming Injection ---
// This stylesheet is injected once and handles light/dark modes and hover effects.
const swalStyle = `
    .swal-confirm-button-custom {
        border-radius: 0.5rem !important;
        padding: 0.75rem 1.5rem !important;
        font-weight: 600 !important;
        transition: background-color 0.2s !important;
        color: white !important;
    }
    .swal-confirm-button-custom:hover {
        background-color: #020102 !important;
    }
    .swal-cancel-button-custom {
        background-color: #6b7280 !important; /* gray-500 */
        color: white !important;
        border-radius: 0.5rem;
        padding: 0.75rem 1.5rem;
        font-weight: 600;
        margin-left: 0.75rem;
    }
    .swal-cancel-button-custom:hover {
        background-color: #4b5563 !important; /* gray-600 */
    }
    
    /* Light Mode Default */
    .swal2-popup { background: #ffffff !important; color: #1f2937 !important; }
    .swal2-title { color: #111827 !important; }
    .swal2-html-container { color: #4b5563 !important; }

    /* Dark Mode Styling */
    .dark .swal2-popup { background: #111c44 !important; color: #ffffff !important; }
    .dark .swal2-title { color: #ffffff !important; }
    .dark .swal2-html-container { color: #d1d5db !important; }
`;
const styleEl = document.createElement('style');
styleEl.id = 'swal-custom-styles'; 
if (!document.getElementById(styleEl.id)) {
    styleEl.innerHTML = swalStyle;
    document.head.appendChild(styleEl);
}

/**
 * A reusable function to fire a SweetAlert2 modal with consistent theming.
 * @param {object} options - The configuration for the alert.
 * @param {string} options.title - The title of the alert.
 * @param {string} options.text - The body text of the alert.
 * @param {('success'|'error'|'warning'|'info'|'question')} options.icon - The icon for the alert.
 * @param {('confirm'|'delete'|'info')} [options.actionType='info'] - Determines the confirm button color. 'delete' is red, others are orange.
 * @returns {Promise<SweetAlertResult>} A promise that resolves with the SweetAlert2 result.
 */
export const fireSwal = (options) => {
    const { title, text, icon, actionType = 'info', ...rest } = options;

    let confirmButtonColor;
    switch (actionType) {
        case 'delete':
            confirmButtonColor = '#d33'; // Red for destructive actions
            break;
        case 'confirm':
        case 'info':
        default:
            confirmButtonColor = '#ff6600'; // Orange for standard confirmations
            break;
    }

    return Swal.fire({
        title,
        text,
        icon,
        confirmButtonColor,
        customClass: {
            confirmButton: 'swal-confirm-button-custom',
            cancelButton: 'swal-cancel-button-custom',
        },
        ...rest, // Pass through any other valid Swal options (e.g., showCancelButton)
    });
};
